import React, { PropsWithChildren } from 'react'
import { Classes } from 'jss'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
import MobileMenu from 'components/svgComponent/Menu'

export type ContentCardPaddingType = 'default' | 'sm' | 'xs' | 'none'

interface Props extends PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  classes: Classes
  color?: string
  title?: string
  noPaddings?: boolean
  row?: boolean
  onHoverEffect?: boolean
  padding?: ContentCardPaddingType
  removeHeaderBotPadding?: boolean
  overflow?: 'unset' | 'auto'
  rightTitle?: React.ReactChild
}

const Card = ({
  classes,
  children,
  className,
  color,
  title,
  noPaddings,
  row,
  padding,
  rightTitle,
  overflow,
  onHoverEffect,
  removeHeaderBotPadding,
  ...rest
}: Props) => {
  const getPadding = () => {
    switch (padding) {
      case 'xs':
        return classes.rootXs
      case 'sm':
        return classes.rootSm
      case 'none':
        return ''

      case 'default':
      default:
        return classes.rootDefault
    }
  }
  return (
    <div
      {...rest}
      style={{ backgroundColor: color, ...rest.style }}
      className={`${classes.root} ${noPaddings && classes.rootNoPaddings} ${row &&
        classes.row} ${className} ${overflow === 'auto' && classes.overflow} ${getPadding()} ${onHoverEffect &&
        classes.hoverRoot}`}
    >
      {(title || rightTitle) && (
        <div
          className={`${classes.topContainer} d-flex ${!removeHeaderBotPadding &&
            classes.topContainerPadding}`}
        >
          <div className="text-20 text-medium">{title}</div>
          {rightTitle}
        </div>
      )}
      {children}
    </div>
  )
}

export default injectSheet(sheet)(Card)
